export const types_translations = {
    // customId
    TRIVIA: {
        name: {
            en: `Trivia Quiz`,
            ru: `Тесты «Проверь себя»`,
        },
        description: {
            en: `Trivia quizzes are one of the most common types of game mechanics. Users can test their knowledge, for example, how well do they know geography. Create stunning and high-performance quizzes in minutes.`,
            ru: `Тесты (или квизы) – один из самых распространенных видов игровых механик. При помощи тестов «Проверь себя» можно проверить знания. Например, хорошо ли вы разбираетесь в музыке?`,
        },
    },
    PERSONALITY: {
        name: {
            en: `Personality Quiz`,
            ru: `Тесты «Узнай себя»`,
        },
        description: {
            en: `A personality quiz helps users to find interesting facts about themselves. There are no correct or wrong answers. For example, what type of temper do you have? Create your own quiz in minutes for free!`,
            ru: `В тестах «Узнай себя» нет правильных и неправильных ответов. Этот тест помогает пользователям узнавать интересные факты о самих себе. Например, вы зануда или душа компании?`,
        },
    },
    PHOTOSTORY: {
        name: {
            en: `Photostory`,
            ru: `Фотоистории`,
        },
        description: {
            en: `Create a wonderful story! Photostories are useful for discovering history facts, ratings, product reviews, and many others.`,
            ru: `Создайте красивое слайдшоу для вашего сайта или блога. Добавьте подписи и социальные кнопки – и у вас получится настоящая фотоистория!`,
        },
    },
    QUOTES: {
        name: {
            en: `Quotes`,
            ru: `Цитаты`,
        },
        description: {
            en: `Quotes are a special format with which you can recall the statements of famous people, the promises of politicians, the rules of life of movie stars. Tell your own story!`,
            ru: `Цитаты – это особый формат, с помощью которого можно вспомнить высказывания известных людей, обещания политиков, правила жизни кинозвезд. Расскажите свою собственную историю!`,
        },
    },
    MEMORY: {
        name: {
            en: `Memory`,
            ru: `Игры Мемори`,
        },
        description: {
            en: `Create a pair with our Memory game. The game allows you to search for identical cards or cards similar in meaning.`,
            ru: `В простом варианте игры Мемори задача игрока – найти одинаковые изображения. Но использовать этот формат можно и для серьезных проектов. Например, сможете ли вы найти пару для всех вымирающих тигров?`,
        },
    },
    RANK_BATTLE: {
        name: {
            en: `Rank Battle`,
            ru: `Рейтинг-баттл`,
        },
        description: {
            en: `Turn voting into a real battle! In this format, for each option, you can vote endlessly, putting it in the top. Which football club is better? Who needs the dress more?`,
            ru: `Превратите голосование в настоящий баттл! В этом формате за каждый вариант можно голосовать бесконечно, выводя его в топ. Какой футбольный клуб лучше? Кому платье идет больше?`,
        },
    },
    BEFORE_AFTER: {
        name: {
            en: `Then/Now`,
            ru: `До и после`,
        },
        description: {
            en: `Then/Now is ideal for creating frame comparisons. Create your own then/now or before/after stories. Compare city streets today and a hundred years ago, or show a famous actor in his youth and now.`,
            ru: `Формат «До и после» (было / стало) идеально подходит для сравнения изображений. Создайте свою историю «До и после»: сравните улицы города «тогда и сейчас», покажите известных людей в юности и сегодня, результат таяния ледников или других событий.`,
        },
    },
    BLOCK_ARTICLE: {
        name: {
            en: `Instant pages`,
            ru: `Встраиваемые статьи`,
        },
        description: {
            en: `Easily create website pages, blog posts and longreads with interactive content that can be embedded on your site, landing pages or app with a simple copy and paste. All Interacty Instant Pages will look equally good on different devices.`,
            ru: `С легкостью создавайте и встраивайте на ваш сайт публикации и целые лонгриды с интерактивным контентом! Добавляйте текст, картинки, флип-карты, тесты и публикуйте: просто скопируйте строчку кода – и проект станет частью вашего сайта.`,
        },
    },
    IP_TEST: {
        name: {
            en: `Instant pages (NEW)`,
            ru: `Встраиваемые статьи (NEW)`,
        },
        description: {
            en: `Easily create website pages, blog posts and longreads with interactive content that can be embedded on your site, landing pages or app with a simple copy and paste. All Interacty Instant Pages will look equally good on different devices.`,
            ru: `С легкостью создавайте и встраивайте на ваш сайт публикации и целые лонгриды с интерактивным контентом! Добавляйте текст, картинки, флип-карты, тесты и публикуйте: просто скопируйте строчку кода – и проект станет частью вашего сайта.`,
        },
    },
    NEW_BLOCK_ARTICLE: {
        name: {
            en: `Instant pages`,
            ru: `Встраиваемые статьи`,
        },
        description: {
            en: `Easily create website pages, blog posts and longreads with interactive content that can be embedded on your site, landing pages or app with a simple copy and paste. All Interacty Instant Pages will look equally good on different devices.`,
            ru: `С легкостью создавайте и встраивайте на ваш сайт публикации и целые лонгриды с интерактивным контентом! Добавляйте текст, картинки, флип-карты, тесты и публикуйте: просто скопируйте строчку кода – и проект станет частью вашего сайта.`,
        },
    },
}

export const editor_translations = [
    {
        name: 'i18n__upload',
        identifier: 'class',
        locales: {
            en: 'Upload',
            ru: 'Загрузить',
        },
    },
    {
        name: 'i18n__delete',
        identifier: 'class',
        locales: {
            en: 'Delete',
            ru: 'Удалить',
        },
    },
    {
        name: 'i18n__add_option',
        identifier: 'class',
        locales: {
            en: 'Clone option',
            ru: 'Клонировать вариант ответа',
        },
    },
    {
        name: 'i18n_main__components',
        identifier: 'id',
        locales: {
            en: 'Components',
            ru: 'Компоненты',
        },
    },
    {
        name: 'i18n_main__project_settings',
        identifier: 'id',
        locales: {
            en: 'Project settings',
            ru: 'Настройки проекта',
        },
    },
    {
        name: 'i18n_main__expert_mode',
        identifier: 'id',
        locales: {
            en: 'Expert mode',
            ru: 'Режим Эксперт',
        },
    },
    {
        name: 'i18n_slidegroupcontrol__delete_slide',
        identifier: 'class',
        locales: {
            en: 'Delete slide',
            ru: 'Удалить слайд',
        },
    },
    {
        name: 'i18n_slidegroupcontrol__clone_slide',
        identifier: 'class',
        locales: {
            en: 'Clone this slide',
            ru: 'Клонировать слайд',
        },
    },
    {
        name: 'i18n_slidegroupcontrol__add_page',
        identifier: 'class',
        locales: {
            en: 'Add new project<br/>page here',
            ru: 'Добавить здесь<br/>новую страницу',
        },
    },
]
